import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { CheckoutCustomerDetailsTranslationDictionary } from './checkout-customer-details-dictionary.interface';

export const translation: TranslationDictionaryMapping<CheckoutCustomerDetailsTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      CHECKOUT_CUSTOMER_DETAILS_TITLE: 'Your details',
      CHECKOUT_CUSTOMER_TITLE: 'Title',
      CHECKOUT_CUSTOMER_NAME: 'Name',
      CHECKOUT_CUSTOMER_EMAIL: 'Email',
      CHECKOUT_CUSTOMER_PHONE: 'Phone',
      CHECKOUT_CUSTOMER_ADDRESS: 'Address',
    },
    [LocaleId.English_Ireland]: {
      CHECKOUT_CUSTOMER_DETAILS_TITLE: 'Your details',
      CHECKOUT_CUSTOMER_TITLE: 'Title',
      CHECKOUT_CUSTOMER_NAME: 'Name',
      CHECKOUT_CUSTOMER_EMAIL: 'Email',
      CHECKOUT_CUSTOMER_PHONE: 'Phone',
      CHECKOUT_CUSTOMER_ADDRESS: 'Address',
    },
    [LocaleId.English_US]: {
      CHECKOUT_CUSTOMER_DETAILS_TITLE: 'Your details',
      CHECKOUT_CUSTOMER_TITLE: 'Title',
      CHECKOUT_CUSTOMER_NAME: 'Name',
      CHECKOUT_CUSTOMER_EMAIL: 'Email',
      CHECKOUT_CUSTOMER_PHONE: 'Phone',
      CHECKOUT_CUSTOMER_ADDRESS: 'Address',
    },
  };
